// src/components/brandCustomization/EmailCustomization/EmailTemplateForm.jsx
import React from 'react';
import { TextInput, TextArea } from '../shared';
import { defaultEmailTexts } from '../../../utils/brandCustomization';

/**
 * EmailTemplateForm - Formulario genérico para textos de email templates
 */
const EmailTemplateForm = ({
    templateName,
    values,
    onChange
}) => {
    // Obtener valores por defecto para este template
    const defaults = defaultEmailTexts[templateName] || {};

    return (
        <div className="space-y-4">
            <TextInput
                label="Saludo"
                hint="(usa {{nombre}} para personalizar)"
                value={values?.greeting ?? ''}
                onChange={(value) => onChange('greeting', value)}
                placeholder={defaults.greeting || '¡Hola {{nombre}}!'}
            />

            <TextArea
                label="Mensaje Principal"
                hint="(puedes usar variables como {{brandName}}, {{link}}, etc.)"
                value={values?.mainMessage ?? ''}
                onChange={(value) => onChange('mainMessage', value)}
                rows={4}
                placeholder={defaults.mainMessage || 'Escribe el mensaje principal del email...'}
            />

            <TextInput
                label="Texto del Botón (CTA)"
                value={values?.ctaText ?? ''}
                onChange={(value) => onChange('ctaText', value)}
                placeholder={defaults.ctaText || 'Ver Mi Tarjeta'}
            />

            <TextArea
                label="Mensaje de Cierre"
                value={values?.closingMessage ?? ''}
                onChange={(value) => onChange('closingMessage', value)}
                rows={2}
                placeholder={defaults.closingMessage || 'Si tienes alguna pregunta, no dudes en contactarnos.'}
            />

            <TextArea
                label="Texto del Footer"
                hint="(puedes usar HTML: <br>, <b>, etc.)"
                value={values?.footerText ?? ''}
                onChange={(value) => onChange('footerText', value)}
                rows={3}
                placeholder={defaults.footerText || 'Saludos,<br>Equipo {{brandName}}'}
            />
        </div>
    );
};

export default EmailTemplateForm;

